import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, ZoomControl, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import Desktop from './components/Desktop';

// MapController manages program-driven zooming and panning to markers
function MapController({ target }) {
    const map = useMap();
    useEffect(() => {
        if (target) {
            map.flyTo(target.coords, target.zoom, {
                animate: true,
                duration: 2.0
            });
        }
    }, [target, map]);
    return null;
}

// Coordinate markers mapping projects
const mapProjects = [
    {
        id: 'water',
        name: 'Smart Water Utility Data',
        coords: [51.5074, 0.1278],
        location: 'London, UK',
        desc: 'Real-time SCADA telemetry visualization and network monitoring.'
    },
    {
        id: 'geospatial',
        name: 'Geospatial Dam Levels Visualisation',
        coords: [-33.9249, 18.4241],
        location: 'Cape Town, SA',
        desc: 'Public dam level visualisation tool'
    },
    {
        id: 'Bussiness',
        name: 'Contarctor Web page',
        coords: [54.8909, -2.9440],
        location: 'Cumbria, UK',
        desc: 'Local Contractor Bussiness'
    }
];

function App() {
    const [mapTarget, setMapTarget] = useState(null);
    const [mapTheme, setMapTheme] = useState('light'); // default to 'light' for high visibility

    // Styled custom marker using Leaflet divIcon and CSS transitions
    const getCustomIcon = (isActive) => {
        return L.divIcon({
            className: 'custom-leaflet-marker-wrapper',
            html: `<div style="
                width: 16px;
                height: 16px;
                background-color: ${isActive ? '#22c55e' : '#38bdf8'};
                border: 3px solid #020617;
                border-radius: 50%;
                box-shadow: 0 0 12px ${isActive ? '#22c55e' : '#38bdf8'}, 0 0 4px rgba(255, 255, 255, 0.4);
                transition: all 0.25s ease;
            "></div>`,
            iconSize: [16, 16],
            iconAnchor: [8, 8]
        });
    };

    const handleLocateProject = (projectId) => {
        const proj = mapProjects.find(p => p.id === projectId);
        if (proj) {
            setMapTarget({ coords: proj.coords, zoom: 8, id: projectId });
        }
    };

    return (
        <>
            <MapContainer
                id="map"
                center={[-30.5595, 22.9375]}
                zoom={6}
                minZoom={3}
                maxBounds={[[-90, -180], [90, 180]]}
                maxBoundsViscosity={1.0}
                scrollWheelZoom={true}
                zoomControl={false}
                touchZoom={true}
                attributionControl={false}
                dragging={true}
            >
                <ZoomControl position="bottomright" />
                <TileLayer
                    url={mapTheme === 'dark'
                        // ? "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}@2x.png"
                        // : "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png"
                        ? `https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}@2x.png?key=${process.env.REACT_APP_CARTO_API_KEY || ''}`
                        : `https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png?key=${process.env.REACT_APP_CARTO_API_KEY || ''}`
                    }
                />

                <MapController target={mapTarget} />

                {mapProjects.map((proj) => (
                    <Marker
                        key={proj.id}
                        position={proj.coords}
                        icon={getCustomIcon(mapTarget?.id === proj.id)}
                    >
                        <Popup>
                            <div style={{ fontFamily: 'sans-serif', padding: '2px', minWidth: '160px' }}>
                                <h4 style={{ margin: '0 0 4px 0', color: '#38bdf8', fontSize: '0.85rem', fontWeight: 600 }}>
                                    {proj.name}
                                </h4>
                                <p style={{ margin: '0 0 6px 0', fontSize: '0.76rem', color: '#94a3b8', lineHeight: 1.3 }}>
                                    {proj.desc}
                                </p>
                                <span style={{ fontSize: '0.7rem', color: '#22c55e', fontWeight: 'bold' }}>
                                    📍 {proj.location}
                                </span>
                            </div>
                        </Popup>
                    </Marker>
                ))}
            </MapContainer>

            <Desktop onLocateProject={handleLocateProject} mapTheme={mapTheme} setMapTheme={setMapTheme} />
        </>
    );
}

export default App;
